export default __webpack_public_path__ + "f8ba0121fc4f9e6e11f94de0e037a684.png";